module.exports = __webpack_public_path__ + "static/media/videoSignGrey.e5be288d.svg";